export default "__VITE_ASSET__DQ9i09Iq__"